import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import VueLib from 'vue';
import * as Sentry from '@sentry/browser';
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations';
export default function (ctx, inject) {
  var opts = Object.assign({}, {
    "dsn": "https://463563f2c9d16c7d8d2a55a9ea64aeda@sentry.aequivalent.dev/3",
    "environment": "production",
    "release": "frontoffice@2.55.14"
  }, {
    integrations: [new Dedupe({}), new ExtraErrorData({}), new ReportingObserver({}), new RewriteFrames({}), new Vue(_objectSpread({
      Vue: VueLib
    }, {
      "attachProps": true
    }))]
  });

  // Initialize sentry
  Sentry.init(opts);

  // Inject Sentry to the context as $sentry
  inject('sentry', Sentry);
  ctx.$sentry = Sentry;
}